var styleDataHash = 'c0456eaf';  
export const injectCss = (() => {
  var css = `.Lfoy3{display:grid;gap:var(--ricos-color-picker-color-swatch-gap,12px);grid-template-columns:repeat(auto-fill,var(--ricos-color-picker-color-swatch-size,24px));justify-content:space-between}.jE5ZH{width:var(--ricos-color-picker-color-swatch-size,24px)}.UgrzC{--ricos-color-picker-color-swatch-size:36px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "container": "Lfoy3",
  "colorSwatch": "jE5ZH",
  "medium": "UgrzC"
};